// src/extenders/announcement-bar.js
var AnnouncementBar = class extends HTMLElement {
  constructor() {
    super();
    this.barHeight = 0;
    this.visible = true;
    this.lastScrollY = Math.max(0, window.scrollY);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  connectedCallback() {
    this.measure();
    if (this.lastScrollY > this.barHeight) {
      this.style.transitionDuration = "0ms";
      this.style.transform = `translateY(-${this.barHeight}px)`;
      document.documentElement.style.setProperty("--announcement-bar-visible-height", "0px");
      this.visible = false;
    }
    const header = document.querySelector("[data-header]");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!this.visible)
          this.style.transitionDuration = "";
        if (header)
          header.classList.add("transition-[top]", "duration-300");
      });
    });
    window.dispatchEvent(new CustomEvent("announcement-bar:connected"));
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize, { passive: true });
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }
  measure() {
    this.barHeight = this.offsetHeight;
    document.documentElement.style.setProperty("--announcement-bar-height", `${this.barHeight}px`);
    if (this.visible) {
      document.documentElement.style.setProperty("--announcement-bar-visible-height", `${this.barHeight}px`);
    }
  }
  handleResize() {
    const previousHeight = this.barHeight;
    this.measure();
    if (this.barHeight !== previousHeight) {
      window.dispatchEvent(new CustomEvent("announcement-bar:resized"));
    }
  }
  handleScroll() {
    const currentScrollY = Math.max(0, window.scrollY);
    if (currentScrollY > this.lastScrollY && this.visible && currentScrollY > this.barHeight) {
      this.style.transform = `translateY(-${this.barHeight}px)`;
      document.documentElement.style.setProperty("--announcement-bar-visible-height", "0px");
      this.visible = false;
    } else if (currentScrollY < this.lastScrollY && !this.visible) {
      this.style.transform = "translateY(0)";
      document.documentElement.style.setProperty("--announcement-bar-visible-height", `${this.barHeight}px`);
      this.visible = true;
    }
    this.lastScrollY = currentScrollY;
  }
};
export {
  AnnouncementBar as default
};
